import { createStore } from 'vuex'

const state = {
  dialog: "Concept",
}
const mutations = {
  SET_DIALOG(state, payload) {
    state.dialog = payload;
  }
}
const actions = {}

const store = createStore({
  actions,
  mutations,
  state
})

export default store
